import "./styles/App.css";
import "./fonts/fonts.css";
import { FronteggProvider } from "@frontegg/react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { useLocation } from "react-router-dom";

import { DateTimeProvider } from "./contexts/DateTimeContext";
import { SocketProvider } from "./contexts/SocketContext";
import initDatadog from "./datadog";
import InitializeApp from "./components/initialize-app/InitializeApp";
import TokenRefreshOnVisibility from "./components/token-refresh-on-visibility/TokenRefreshOnVisibility";
import ErrorBoundary from "./layout/ErrorBoundries";
import HeaderSkeleton from "./layout/Header/HeaderSkeleton";
import useAppStore from "./stores/appStore";
import { showHeaderSkeletonSelector } from "./stores/selectors/appSelectors";
import { EXTERNAL_PREVIEW, FRONTEGG_DASHBOARD_BASE_URL, FRONTEGG_DASHBOARD_CLIENT_ID } from "@consts";
import theme from "./theme";
import { queryClient } from "./lib/react-query/queryClient";

if (import.meta.env.VITE_SKIP_DD !== "true") {
  initDatadog();
}

const App = () => {
  const location = useLocation();
  const showHeaderSkeleton = useAppStore(showHeaderSkeletonSelector);
  const isHeaderSkeletonVisible = showHeaderSkeleton && !location.pathname.includes(EXTERNAL_PREVIEW);

  const contextOptions = {
    baseUrl: FRONTEGG_DASHBOARD_BASE_URL,
    clientId: FRONTEGG_DASHBOARD_CLIENT_ID
  };
  const authOptions = {
    keepSessionAlive: true
  };

  return (
    <FronteggProvider
      contextOptions={contextOptions}
      hostedLoginBox
      authOptions={authOptions}
    >
      <TokenRefreshOnVisibility />
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            {isHeaderSkeletonVisible ? <HeaderSkeleton /> : null}
            <SocketProvider>
              <DateTimeProvider>
                <ErrorBoundary key={location.pathname}>
                  <InitializeApp />
                </ErrorBoundary>
              </DateTimeProvider>
            </SocketProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </FronteggProvider>
  );
};

export default App;
